import React, { Component } from 'react';
import { message, Select, Spin } from 'antd';
import _ from 'lodash';
import axios from 'axios';

const { Option } = Select;

class SearchInput extends React.Component {
    constructor(props) {
        super(props);
        this.lastFetchId = 0;
        this.fetchBranches = _.debounce(this.fetchBranches, 800);
    }

    state = {
        data: [],
        value: [],
        fetching: false
    };

    componentDidMount() {
        const { value: initialBranchNo, url } = this.props;
        this.fetchBranch(initialBranchNo);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
            _.debounce(() => this.fetchBranch(nextProps.value), 1000)();
        }
    }

    fetchBranch = (value) => {
        if (!value) return;
        const { url = '/api/accountBanks/picc' } = this.props;
        this.setState({ data: [], fetching: true });
        axios.get(`${url}?accountBankCode=${value}`)
            .then((response) => {
                const body = response.data;
                if (body.errCode !== 0) {
                    message.info(body.errInfo);
                    return;
                }
                const data = body.result.map((bank) => ({
                    text: bank.accountBankName,
                    value: bank.accountBankCode
                }));
                this.setState({ data, fetching: false });
            });
    };

    fetchBranches = (value) => {
        if (!value) return;
        const { url = '/api/accountBanks/picc' } = this.props;
        this.lastFetchId += 1;
        const fetchId = this.lastFetchId;
        this.setState({ data: [], fetching: true });
        axios(`${url}?kw=${value}`)
            .then((response) => {
                const body = response.data;
                if (fetchId !== this.lastFetchId) {
                    // for fetch callback order
                    return;
                }
                if (body.errCode !== 0) {
                    message.info(body.errInfo);
                    return;
                }

                const data = body.result.map((bank) => ({
                    text: bank.accountBankName,
                    value: bank.accountBankCode
                }));
                this.setState({ data, fetching: false });
            });
    };

    handleChange = (value) => {
        this.setState({
            value,
            data: [],
            fetching: false
        });
        this.props.onChange && this.props.onChange(value)
    };

    render() {
        const { fetching, data, value } = this.state;
        const { value: initialBranchNo } = this.props;
        return (
            <Select
                allowClear
                showSearch
                // labelInValue
                value={value || initialBranchNo}
                placeholder="银行支行"
                notFoundContent={fetching ? <Spin size="small" /> : null}
                filterOption={false}
                onSearch={this.fetchBranches}
                onChange={this.handleChange}
                style={{ width: '100%' }}
                {...this.props}
            >
                {data.map((d) => (
                    <Option key={d.value}>{d.text}</Option>
                ))}
            </Select>
        );
    }
}

export default SearchInput;
